/* eslint-disable no-useless-escape */
import moment from 'moment';
import fr from 'moment/locale/fr';
import numeral from 'numeral';
import 'numeral/locales/fr';
import { ActGlo } from '../App_Data/ActionTypes';
import { MDP_TAILLE_MIN, MDP_TAILLE_MAX } from '../App_Data/Consts';

moment.updateLocale('fr', fr);
numeral.locale('fr');

export function obtenirCoproActive(lsCopExts, numAuto) {
    return lsCopExts.find(valeur => valeur.NumAuto === numAuto);
}

export function estMembreCS(lsCopExts, numAuto) {
    const coproActive = obtenirCoproActive(lsCopExts, numAuto);
    return coproActive ? coproActive.Ind.CS === 'M' || coproActive.Ind.CS === 'P' : false;
}

export function estVide(chaine) {
    return !chaine || chaine.length === 0 || !chaine.trim();
}

export function estHTML(str) {
    const reg = /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i;
    return reg.test(str);
}

export function estEmailValide(email) {
    const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(String(email).toLowerCase());
}

export function estTelValide(tel) {
    const reg = /^(?:(?:\+|00)[0-9]{2}[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/;
    return reg.test(String(tel));
}
export function estTelValide2(tel, pays) {
    if (pays !== undefined) {
        if (!tel.startsWith(`+${pays.dialCode}`)) return false;
        if ((pays.countryCode === 'fr' || pays.iso2 === 'fr') && tel.length !== 12) return false;
    }

    const reg = /^((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/;
    return reg.test(String(tel));
}

export function estMotdePasseValide(mdp) {
    return !estVide(mdp) && mdp.length >= MDP_TAILLE_MIN && mdp.length <= MDP_TAILLE_MAX;
}

export function getIcone(icone) {
    return `https://secure.kel-syndic-360.fr/Images/Icons/x16/${icone}`;
}

export function getGlyphe(utilisateur, ...args) {
    const estSyndic = args.length > 0 ? args.shift() : false;
    const iconeDefaut = estSyndic ? getIcone('icon_synx16.png') : getIcone('icon_prox16.png');
    return utilisateur && utilisateur.Glyph > 0
        ? `https://secure.kel-syndic-360.fr/Images/utilisateurs/${utilisateur.Glyph}.png`
        : iconeDefaut;
}

export function getArrondi(valeur) {
    const facteur = 10 ** 2;
    return Math.round(valeur * facteur) / facteur;
}

export function toDate(date, ...args) {
    const format = args.length > 0 ? args.shift() : 'YYYY-MM-DD';
    return moment(date).format(format);
}

export function toCalendrier(date) {
    return moment(date).calendar();
}

export function toSmallCalendrier(date) {
    return moment(date).format('DD/MM/YY');
}

export function fromNow(date) {
    return moment(date).fromNow();
}

export function toEuros(valeur, ...args) {
    const arrondi = getArrondi(valeur);
    const afficheZero = args.length > 0 ? args.shift() : false;
    return !afficheZero && arrondi === 0 ? '' : numeral(arrondi).format('0,0.00');
}

export function makeActionCreator(type, ...argNames) {
    return (...args) => {
        const action = { type };
        argNames.forEach((arg, index) => {
            action[argNames[index]] = args[index];
        });
        return action;
    };
}

export function estEnCoursDeChargement(objet) {
    return objet === ActGlo.EN_COURS_DE_CHARGEMENT;
}

export function nettoyerObjetEmail(objet) {
    return objet.replace(/([[(] *)?(RE|TR|FWD|Problème signalé?) *([-:;)\]][ :;\])-]*|$)|\]+ *$/gim, '');
}

export function obtenirNumeroServeur() {
    return window.env && window.env.NUM_SRV ? window.env.NUM_SRV : 'localhost';
}


export function obtenirNavigateur() {
    let navigateur ="";
    const ua = navigator.userAgent;
    // attention, pour IE, Firefox et Edge le mot Chrome apparait aussi c'est pour ca qu'il est en 5ieme
    // Safari apparait a de nombreuses occasions donc mettre à la fin
    if (ua.indexOf("MSIE")>=1 && navigateur.length<1){navigateur="IE"}
    if (ua.indexOf("Firefox")>=1 && navigateur.length<1){navigateur="Firefox"}
    if (ua.indexOf("Edg")>=1 && navigateur.length<1){navigateur="Edge"}
    if (ua.indexOf("Opera")>=1 && navigateur.length<1){navigateur="Opera"}
    if (ua.indexOf("Chrome")>=1 && navigateur.length<1){navigateur="Chrome"}
    if (ua.indexOf("Safari")>=1 && navigateur.length<1){navigateur="Safari"}
    if (navigateur.length<1){navigateur=ua.substring(0,99)}

    return navigateur;
}



// WEBPACK FOOTER //
// ./src/App_Code/Utils.js